export const SUCCESSFUL_REMOVE_FROM_MY_PORTFOLIO = {
  message: "successful_remove_from_my_portfolio_message",
  severity: "success",
  duration: 5000
}

export const ERROR_IN_REMOVE_FROM_MY_PORTFOLIO = {
  message: "error_remove_from_my_portfolio_message",
  severity: "error",
  duration: 5000
}

export const SUCCESSFUL_ADD_TO_MY_PORTFOLIO = {
  message: "successful_add_to_my_portfolio_message",
  severity: "success",
  duration: 5000
}

export const ERROR_IN_ADD_TO_MY_PORTFOLIO = {
  message: "error_add_to_my_portfolio_message",
  severity: "error",
  duration: 5000
}

export const SUCCESSFUL_FOLLOW_PROJECT = {
  message: "successful_follow_project_message",
  severity: "success"
}

export const ERROR_IN_FOLLOW_PROJECT = {
  message: "error_follow_project_message",
  severity: "error"
}

export const SUCCESSFUL_UNFOLLOW_PROJECT = {
  message: "successful_unfollow_project_message",
  severity: "success"
}

export const ERROR_IN_UNFOLLOW_PROJECT = {
  message: "error_unfollow_project_message",
  severity: "error"
}